import { SetStateAction, useState } from 'react';
import Image from 'next/image';

interface IProps {
  city: string | undefined;
  setCity: React.Dispatch<SetStateAction<string | undefined>>;
  cityFilter: Record<string, any>;
  setCityFilter: React.Dispatch<React.SetStateAction<
    Record<string, any>
  > | null>;
  citiesDropdown: Record<string, any>[] | undefined;
  citiesToggle: boolean;
  setCitiesToggle: React.Dispatch<SetStateAction<boolean>>;
  currentPage: number;
  setCurrentPage: React.Dispatch<SetStateAction<number>>;
}
const sortCities = (cities: any) => {
  const sortedCities = cities
    ?.slice()
    .sort((a: any, b: any) => a.city.name.localeCompare(b.city.name));
  return sortedCities;
};

const CitiesSorting = ({
  cityFilter,
  setCityFilter,
  citiesDropdown,
  city,
  setCity,
  citiesToggle,
  setCitiesToggle,
  currentPage,
  setCurrentPage
}: IProps) => {
  const sortedCitiesDropdown = sortCities(citiesDropdown);
  return (
    <div id="reviews-cities-dropdown" className="relative">
      <div>
        <span className="text-sm sm:text-[18px] text-[#333333] font-[400]">
          Filter By City:
        </span>

        <button
          className="pl-1 sm:pl-2 text-sm sm:text-[18px]"
          onClick={() => setCitiesToggle(!citiesToggle)}
        >
          <span className="pl-3">{city ? city : 'ALL'}</span>
          <span className="inline-block pl-2">
            <Image
              src={
                'https://res.cloudinary.com/see-sight-tours/image/upload/v1686742410/Remaining%20images/Reviews/review-filtercitydropdown_mtjjfv.svg'
              }
              width={15}
              height={15}
              alt="dropdown"
            />
          </span>
        </button>
      </div>
      {citiesToggle && (
        <div className="bg-[#FFFFFF] rounded-b-[5px] max-h-[300px] overflow-y-auto absolute top-[100%] w-[100%] z-[60]">
          <div
            onClick={() => {
              setCityFilter(null);
              setCity('ALL');
              setCurrentPage(0);
            }}
            className="border border-slate-300 px-3 hover:cursor-pointer"
          >
            ALL
          </div>
          {sortedCitiesDropdown.map((city: any) => (
            <div
              key={city?.city.id}
              className="border border-slate-300 px-3 hover:cursor-pointer"
              onClick={() => {
                setCity(city?.city?.name);
                setCurrentPage(0);
                setCityFilter({
                  cities: {
                    id: city?.city?.id,
                    slug: city?.city.slug
                  }
                });
                setCitiesToggle(!citiesToggle);
              }}
            >
              {city?.city.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CitiesSorting;
